import { STELLANTIS_CUSTOMER_POSTMESSAGE_TEMPLATE, STELLANTIS_SUBMIT_POSTMESSAGE_TEMPLATE, stellantisFormSubmitMessageWithParams } from '../utils'

export function sendStellantisCustomerInfoStartMessage(): void {
  postMessageToParentWindow(STELLANTIS_CUSTOMER_POSTMESSAGE_TEMPLATE.message, STELLANTIS_CUSTOMER_POSTMESSAGE_TEMPLATE.target)
}

export function sendStellantisFormSubmitMessage(leadId: string | undefined): void {
  const msgJson = stellantisFormSubmitMessageWithParams(leadId)
  postMessageToParentWindow(JSON.stringify(msgJson), STELLANTIS_SUBMIT_POSTMESSAGE_TEMPLATE.target)
}

function postMessageToParentWindow(message: string, target: string): void {
  parent.postMessage(message, target)
}
